/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ProcurementView.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ProcurementView } from "./ProcurementView";

import { Project } from "./Project";
import { User } from "./User";

export abstract class ProcurementViewModel {
    id: number;
    columns: any;
    createdAt: Dayjs;
    defaultSort: any | null;
    name: string;
    projectId: number;
    updatedAt: Dayjs;
    userId: number;
    project: Project | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        columns: any,
        createdAt: Dayjs,
        defaultSort: any | null,
        name: string,
        projectId: number,
        updatedAt: Dayjs,
        userId: number,
        project: Project | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.columns = columns;
        this.createdAt = createdAt;
        this.defaultSort = defaultSort;
        this.name = name;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.project = project;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): ProcurementView {
        const newObject = new ProcurementView(
            json["id"],
            json["columns"],
            dayjs(json["created_at"]).tz(timezone),
            json["default_sort"],
            json["name"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            columns: this.columns,
            created_at: this.createdAt,
            default_sort: this.defaultSort,
            name: this.name,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            user_id: this.userId,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ProcurementView {
        const clone = Object.create(this) as ProcurementView;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
